/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAlertType } from './InternalApiAlertType';
import {
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeFromJSONTyped,
    InternalApiAlertTypeToJSON,
    InternalApiAlertTypeToJSONTyped,
} from './InternalApiAlertType';

/**
 * Unique alert identity
 * @export
 * @interface InternalApiAlertId
 */
export interface InternalApiAlertId {
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertId
     */
    alertId: number;
    /**
     * 
     * @type {InternalApiAlertType}
     * @memberof InternalApiAlertId
     */
    alertType: InternalApiAlertType;
}



/**
 * Check if a given object implements the InternalApiAlertId interface.
 */
export function instanceOfInternalApiAlertId(value: object): value is InternalApiAlertId {
    if (!('alertId' in value) || value['alertId'] === undefined) return false;
    if (!('alertType' in value) || value['alertType'] === undefined) return false;
    return true;
}

export function InternalApiAlertIdFromJSON(json: any): InternalApiAlertId {
    return InternalApiAlertIdFromJSONTyped(json, false);
}

export function InternalApiAlertIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertId {
    if (json == null) {
        return json;
    }
    return {
        
        'alertId': json['alertId'],
        'alertType': InternalApiAlertTypeFromJSON(json['alertType']),
    };
}

export function InternalApiAlertIdToJSON(json: any): InternalApiAlertId {
    return InternalApiAlertIdToJSONTyped(json, false);
}

export function InternalApiAlertIdToJSONTyped(value?: InternalApiAlertId | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alertId': value['alertId'],
        'alertType': InternalApiAlertTypeToJSON(value['alertType']),
    };
}

